import { render, staticRenderFns } from "./RejectOrderRowModal.vue?vue&type=template&id=13fc9e9e&scoped=true"
import script from "./RejectOrderRowModal.vue?vue&type=script&lang=ts"
export * from "./RejectOrderRowModal.vue?vue&type=script&lang=ts"
import style0 from "./RejectOrderRowModal.vue?vue&type=style&index=0&id=13fc9e9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc9e9e",
  null
  
)

export default component.exports